import { addUUID, removeUUID } from "../constants/userConstant";

const UUIDData = {
  UUID: null,
};

const UUIDReducer = (state = UUIDData, action) => {
  switch (action.type) {
    case addUUID:
      const { uuid } = action.payload;
      return { UUID: uuid };
    case removeUUID:
      return { UUID: null };
    default:
      return state;
  }
};

export default UUIDReducer;
